interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0A1628]/95 backdrop-blur-sm shadow-lg' : 'bg-[#0A1628]/85'
      }`}
    >
      <div className="w-full px-10">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/6e8e447b-345b-4045-8ebb-50f9e52f5ebf.png" 
              alt="J. N. DOS S. MELO LTDA Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className="text-white font-semibold text-lg whitespace-nowrap">J. N. DOS S. MELO LTDA</span>
          </div>

          <div className="flex items-center gap-12">
            <button
              onClick={() => scrollToSection('home')}
              className="text-[#B8C5D6] hover:text-white transition-colors duration-200 text-base whitespace-nowrap"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className="text-[#B8C5D6] hover:text-white transition-colors duration-200 text-base whitespace-nowrap"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-[#B8C5D6] hover:text-white transition-colors duration-200 text-base whitespace-nowrap"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-[#B8C5D6] hover:text-white transition-colors duration-200 text-base whitespace-nowrap"
            >
              Contact
            </button>
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="bg-[#00D9FF] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#00C4E6] transition-all duration-200 shadow-lg hover:shadow-[#00D9FF]/50 whitespace-nowrap"
          >
            Get Started
          </button>
        </div>
      </div>
    </nav>
  );
}
